// src/app/google-redirect/google-redirect.component.ts
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-google-redirect',
  template: `<p>{{ errorMessage }}</p>`,
})
export class GoogleRedirectComponent implements OnInit {
  errorMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    // private loggingService: LoggingService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.errorMessage = params['error'];
      if (this.errorMessage) {
        console.error('Google Auth Error:', this.errorMessage);
        //this.loggingService.logError(this.errorMessage);
      }
    });
  }
}
